export const GOLD  = "#F9A826";
export const GOLD2 = "#FFD166";
export const BLUE  = "#0f1729";
export const SENHA_ADMIN = "louvor2025";

export const TEMAS = {
    escuro: {
        bg:              "#0f1729",
        bgCard:          "#1a2540",
        bgCardSecundario:"#0f1729",
        texto:           "#ffffff",
        textoSecundario: "#8899bb",
        borda:           "#2a3a5c",
        nav:             "#111e35",
        input:           "#1a2540",
    },
    claro: {
        bg:              "#f0f2f8",
        bgCard:          "#ffffff",
        bgCardSecundario:"#f0f2f8",
        texto:           "#0f1729",
        textoSecundario: "#667799",
        borda:           "#dde3f0",
        nav:             "#ffffff",
        input:           "#f0f2f8",
    },
};

// ─ 12 notas sem duplicatas (C# não aparece junto com Db) ─────
// O App.js usa TONS_UI do Transposer.js. Este array é mantido
// apenas para compatibilidade com código legado.
export const TONS = ["C","C#","D","D#","E","F","F#","G","G#","A","A#","B"];

export const VOZ_CORES = {
    Soprano:  { cor: "#e91e63" },
    Contralto:{ cor: "#9c27b0" },
    Tenor:    { cor: "#2196f3" },
    Barítono: { cor: "#4caf50" },
};